<template>
  <div class="content">
    <Header></Header>
    <div v-show="this.isApp == true ? false : true" class="main">
      <MainLeft></MainLeft>
      <div class="main_content">
        <div class="navigation">
          {{ $t("teaching.home") }} >> {{ titleName }}
        </div>
        <div class="main-bod">
          <div class="title-con">
            <div
              @click="changeTilte(item, index)"
              :class="cieTitle == index ? 'title-item-sub' : 'title-item'"
              v-for="(item, index) in titleList"
              :key="index"
            >
              <div>{{ item.title }}</div>
            </div>
          </div>
          <div class="exchange-con" v-show="isTitle1">
            <div class="select">{{ $t("gift.t16") }}</div>
            <div class="exchange-med">
              <div
                @click="changeExchange(item, index)"
                class="exchange-med-item"
                v-for="(item, index) in exchangeList"
                :key="index"
              >
                <img
                  :class="
                    cieExchange == index
                      ? 'exchange-med-img-sub'
                      : 'exchange-med-img'
                  "
                  :src="item.ico"
                  alt=""
                />
              </div>
            </div>
            <div v-show="isExchange">
              <div class="exchange-tip">
                <div class="exchange-tip-item">{{ $t("gift.t3") }}</div>
                <div class="exchange-tip-item">{{ $t("gift.t4") }}</div>
                <div class="exchange-tip-item">{{ $t("gift.t5") }}</div>
              </div>
              <div class="line"></div>
              <div class="">
                <div class="exchange-tip-item">{{ $t("gift.t6") }}</div>
                <div class="ipt-wid">
                  <input
                    type="text"
                    v-model="isCoin"
                    :placeholder="this.minPrice"
                    class="iptPhr"
                    @blur="getValue"
                  />
                  <span class="ipt-wid-span" v-show="isTips">{{$t('gift.t37')}}</span>
                  <!-- <input type="text" :placeholder="this.minPrice" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')"> -->
                </div>
                <div class="amount-con">
                  <span>{{ $t("gift.t17") }}</span
                  ><span class="gift-amount">{{ isAct }}</span>
                </div>
              </div>

              <!-- newEcg -->
              <div>
                <div>
                  <div v-for="(item, index) in propList" :key="index">
                    <div
                      v-show="item.ViewType == 1 ? true : false"
                      class="clo-1"
                    >
                      <div
                        v-show="lange == 'en' ? true : false"
                        class="clo-1-title"
                      >
                        {{ item.Title.en }}
                      </div>
                      <div
                        v-show="lange == 'zh' ? true : false"
                        class="clo-1-title"
                      >
                        {{ item.Title.zh }}
                      </div>
                      <el-select v-model="cievalue[index]" placeholder="please select">
                        <el-option
                          v-for="(itemSub, indexSub) in item.SelectionLabel"
                          :key="indexSub"
                          :label="itemSub"
                          :value="itemSub"
                        >
                        </el-option>
                      </el-select>
                    </div>

                    <div
                      v-show="item.ViewType == 0 ? true : false"
                      class="clo-1"
                    >
                      <div
                        v-show="lange == 'en' ? true : false"
                        class="clo-1-title"
                      >
                        {{ item.Title.en }}
                      </div>
                      <div
                        v-show="lange == 'zh' ? true : false"
                        class="clo-1-title"
                      >
                        {{ item.Title.zh }}
                      </div>
                      <div class="clo-1-cte">{{ item.Value }}</div>
                    </div>
                  </div>
                  <!-- <div class="know-con">
                    <input
                      @click="changeRadio"
                      type="checkbox"
                      class="cieRadio"
                      v-model="radioCie"
                    />
                    <div @click="changeRadio" :class="this.isCfm == true? 'know-con-sub':'know-con-s'">{{ $t("gift.t34") }}</div>
                  </div> -->
                </div>
              </div>

              <div class="submit-con">
                <div class="submit" @click="getPayoutOk">
                  {{ $t("gift.t10") }}
                </div>
              </div>
            </div>
          </div>
          <!-- <Record v-show="isTitle2" :upData="changeValue"></Record> -->
          <Record v-show="isTitle2" ref="child"></Record>
        </div>
      </div>
    </div>

    <div v-show="this.isApp == false ? false : true" class="main-h5">
      <div class="main_content-h5">
        <div class="navigation">{{ $t("teaching.home") }} >></div>
        <div class="main-bod">
          <div class="title-con">
            <div
              @click="changeTilte(item, index)"
              :class="cieTitle == index ? 'title-item-sub' : 'title-item'"
              v-for="(item, index) in titleList"
              :key="index"
            >
              <div>{{ item.title }}</div>
            </div>
          </div>
          <div class="exchange-con" v-show="isTitle1">
            <div class="select">{{ $t("gift.t16") }}</div>
            <div class="exchange-med">
              <div
                @click="changeExchange(item, index)"
                class="exchange-med-item"
                v-for="(item, index) in exchangeList"
                :key="index"
              >
                <img
                  :class="
                    cieExchange == index
                      ? 'exchange-med-img-sub'
                      : 'exchange-med-img'
                  "
                  :src="item.ico"
                  alt=""
                />
              </div>
            </div>
            <div v-show="isExchange">
              <div class="exchange-tip">
                <div class="exchange-tip-item">{{ $t("gift.t3") }}</div>
                <div class="exchange-tip-item">{{ $t("gift.t4") }}</div>
                <div class="exchange-tip-item">{{ $t("gift.t5") }}</div>
              </div>
              <div class="line"></div>
              <div class="">
                <div class="exchange-tip-item">{{ $t("gift.t6") }}</div>
                <div class="ipt-wid-h5">
                  <input
                    type="text"
                    v-model="isCoin"
                    :placeholder="this.minPrice"
                    class="iptPhr-h5"
                    @blur="getValue"
                  />
                  <span class="ipt-wid-span-h5" v-show="isTips">{{$t('gift.t37')}}</span>
                  <!-- <input type="text" :placeholder="this.minPrice" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')"> -->
                </div>
                <div class="amount-con">
                  <span>{{ $t("gift.t17") }}</span
                  ><span class="gift-amount">{{ isAct }}</span>
                </div>
              </div>

              <!-- newEcg -->
              <div>
                <div>
                  <div v-for="(item, index) in propList" :key="index">
                    <div
                      v-show="item.ViewType == 1 ? true : false"
                      class="clo-1"
                    >
                      <div
                        v-show="lange == 'en' ? true : false"
                        class="clo-1-title"
                      >
                        {{ item.Title.en }}
                      </div>
                      <div
                        v-show="lange == 'zh' ? true : false"
                        class="clo-1-title"
                      >
                        {{ item.Title.zh }}
                      </div>
                      <el-select v-model="cievalue[index]" placeholder="please select">
                        <el-option
                          v-for="(itemSub, indexSub) in item.SelectionLabel"
                          :key="indexSub"
                          :label="itemSub"
                          :value="itemSub"
                        >
                        </el-option>
                      </el-select>
                    </div>

                    <div
                      v-show="item.ViewType == 0 ? true : false"
                      class="clo-1"
                    >
                      <div
                        v-show="lange == 'en' ? true : false"
                        class="clo-1-title"
                      >
                        {{ item.Title.en }}
                      </div>
                      <div
                        v-show="lange == 'zh' ? true : false"
                        class="clo-1-title"
                      >
                        {{ item.Title.zh }}
                      </div>
                      <div class="clo-1-cte">{{ item.Value }}</div>
                    </div>
                  </div>
                  <!-- <div class="know-con">
                    <input
                      @click="changeRadio"
                      type="checkbox"
                      class="cieRadio"
                      v-model="radioCie"
                    />
                    <div @click="changeRadio" :class="this.isCfm == true? 'know-con-sub':'know-con-s'">{{ $t("gift.t34") }}</div>
                  </div> -->
                </div>
              </div>
              <div class="submit-con">
                <div class="submit" @click="getPayoutOk">
                  {{ $t("gift.t10") }}
                </div>
              </div>
            </div>
          </div>
          <Record v-show="isTitle2" ref="child"></Record>
        </div>
      </div>
    </div>
    <My-popup
      :popupMsg="popupMsg"
      @handlePopup="handleShowOrHidePopup"
      v-show="showPopup"
    />
    <Login-pop ref="LoginPop"></Login-pop>
    <Footer></Footer>
    <router-view />
  </div>
</template>
<script>
import "../assets/h5/gift.css";
import { mapActions, mapState, mapMutations } from "vuex";
import Record from "../components/record";
export default {
  components: { Record },
  data() {
    return {
      bankValue: "",
      changeValue: "",
      msg: "1",
      isTitle1: true,
      isTitle2: false,
      isExchange: false,
      isCoin: "",
      visible: false,
      isLoginShow: true,
      extractListTpye: "",
      cieTitle: 0,
      cieExchange: -1,
      exchangeList: [],
      bankDetail: {},
      minPrice: "",
      bankName: "",
      showPopup: false,
      popupMsg: {
        title: "",
        content: "",
        // cancel:'取消',
        confirm: "ok",
      },
      jumpNum: 0,
      titleName: "",
      ifscShow: false,
      isifscTips: false,
      taxShow: false,
      istaxTips: false,
      ifscNum: "",
      taxNum: "",
      bankAct: "", //因为ifsc/tax为1时拼接在一起需要做判断
      isbind: false,
      bankAccountName: "",
      phoneNum: "",
      cieBankList: [],
      propList: [],
      cievalue: [],
      lange: "",
      prop_list: "",
      radioCie: false,
      isTips:false,
      isCfm:false,
    };
  },
  created() {
    this.getExtractList();
    var lange = localStorage.getItem("lang");
    if (lange == "en") {
      this.lange = "en";
    }
    if (lange == "zh") {
      this.lange = "zh";
    }
  },
  mounted() {
    this.isLogin();
    this.jumpNum = this.$route.query.jumpNum;
    if (this.jumpNum == 1) {
      this.titleName = this.titleList[1].title;
      this.cieTitle = 1;
      this.isTitle1 = false;
      this.isTitle2 = true;
    } else {
      this.titleName = this.titleList[0].title;
      this.isTitle1 = true;
      this.isTitle2 = false;
    }
  },
  computed: {
    ...mapState({
      hasLogin(state) {
        return state.hasLogin;
      },
      isApp(state) {
        return state.isApp;
      },
      tokenData(state) {
        return state.tokenData;
      },
    }),
    titleList() {
      return [
        {
          title: this.$t("gift.t1"),
        },
        {
          title: this.$t("gift.t2"),
        },
      ];
    },
    isAct() {
      let aa = this.isCoin;
      let bb = this.bankDetail.ChipExchangeRate;
      let cc = this.isCoin * bb;
      return this.bankDetail.Currency + " " + cc;
    },
  },
  methods: {
    ruIdsc() {
      if (this.ifscNum.length == 11) {
        this.isifscTips = false;
      } else {
        this.isifscTips = true;
      }
    },
    ruTax() {
      if (this.taxNum.length == 11) {
        this.istaxTips = false;
      } else {
        this.istaxTips = true;
      }
    },
    isLogin() {
      if (this.hasLogin == "1") {
        this.$refs.LoginPop.showLogin();
      }
    },
    //获取兑换列表接口
    getExtractList() {
      var _that = this;
      let obj = {
        token: _that.tokenData,
      };
      this.$FucPost(this.$store.state.ip + "/getExtractList", obj)
        .then(function (res) {
          let resData = res.data.switchlist;
          _that.exchangeList = resData;
          // console.log("_that.exchangeList", _that.exchangeList);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取某个方式的兑换信息接口
    getCreditInfo() {
      var _that = this;
      let obj = {
        type: _that.extractListTpye,
        token: _that.tokenData,
      };
      this.$FucPost(this.$store.state.ip + "/getCreditInfo", obj)
        .then(function (res) {
          // console.log("getCreditInfo-res", res);
          let resData = res.data;
          // console.log("resData", resData);
          _that.bankDetail = resData;
          let min = resData.MinExtractCredit.toString();
          _that.minPrice =
            // _that.$t("gift.t11") + " " + resData.Currency + min.slice(0, -2);
            _that.$t("gift.t11") + " " + resData.MinExtractCredit; //最低限额
          _that.bankName = resData.BankName[0]; //收款银行
          _that.bankAccountName = resData.BankAccountName; //收款人名字
          _that.phoneNum = resData.PhoneNum; // 手机号
          //是否绑定银行信息（根据有无BankAccountName判断）
          if (resData.BankAccountName != undefined) {
            _that.isbind = true;
          }
          if (resData.BankAccountName == undefined) {
            _that.isbind = false;
          }
          // console.log('_that.isbind',_that.isbind)

          //获取银行卡号和巴西（ifsc）印度（cpf）(根据BankAccountNo判断)
          var ifsc = res.ifsc;
          var tax = res.tax;
          var actNum = resData.BankAccountNo;
          if (ifsc == 0) {
            _that.ifscShow = false;
            _that.bankAct = resData.BankAccountNo;
          }
          if (ifsc == 1) {
            _that.ifscShow = true;
            _that.ifscNum = actNum.substring(actNum.length - 11);
            _that.bankAct = actNum.slice(0, -11);
          }
          if (tax == 0) {
            _that.taxShow = false;
            _that.bankAct = resData.BankAccountNo;
          }
          if (tax == 1) {
            _that.taxShow = true;
            _that.taxNum = actNum.substring(actNum.length - 11);
            _that.bankAct = actNum.slice(0, -11);
          }

          //获取未绑定时选择的银行
          _that.cieBankList = resData.bankList;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //newgai
    getPayoutInfo() {
      var _that = this;
      let obj = {
        token: _that.tokenData,
        type: _that.extractListTpye,
      };
      this.$FucPost(this.$store.state.ip + "/getPayoutInfo", obj)
        .then(function (res) {
          let resData = res.data;
          // console.log("resData", resData);
          _that.bankDetail = resData;
          _that.propList = resData.PropList;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //提交兑换信息接口
    //newgai
    getValue() {
      var _that = this;
      // let submitList = _that.
      let plSubmit = _that.propList;
      var prop1 = "";
      var prop2 = "";
      var viewType = [];
      for (let i = 0; i <= plSubmit.length; i++) {
        var viewType = plSubmit[i].ViewType;
        if (viewType == 0) {
          prop1 += plSubmit[i].Prop + "|" + plSubmit[i].Value + ";";
        }
        if (viewType == 1) {
          let cievalue = this.cievalue;
          let wyProp2 = plSubmit[i].Prop;
          for (let j = 0; j <= cievalue.length; j++) {
            let value2 = cievalue[i];
            prop2 = wyProp2 + "|" + value2;
          }
        }
        let ac = prop2 + ";" + prop1;
        _that.prop_list = ac.toString();
      }
    },
    getPayoutOk() {
      if(this.cievalue.length!=0&&this.isCoin!=''){
        var _that = this;
        _that.isTips = true
        let obj = {
          token: _that.tokenData,
          extract_chip: _that.isCoin,
          type: _that.extractListTpye,
          prop_list: _that.prop_list,
        };
        this.$FucPost(this.$store.state.ip + "/getPayoutOk", obj)
          .then(function (res) {
            if (res.code != 200) {
              _that.showPopup = true;
              _that.popupMsg.content = res.msg;
            }
            if (res.code == 200) {
              _that.showPopup = true;
              _that.popupMsg.content = res.msg;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      if(this.cievalue.length==0){
        alert(this.$t('gift.t35'))
      }
      if(this.isCoin==''){
        this.isTips = true
      }
    },
    // submitExtractInfo() {
    //   var _that = this;
    //   var bankCard = _that.bankAct + _that.ifscNum;
    //   if (_that.isbind == false) {
    //     var payee = _that.bankValue;
    //   }
    //   if (_that.isbind == true) {
    //     var payee = _that.bankName;
    //   }
    //   let obj = {
    //     type: _that.extractListTpye,
    //     extract_chip: _that.isCoin,
    //     bank: _that.bankName,
    //     bank_card: bankCard,
    //     payee: payee,
    //     phone_num: _that.bankDetail.PhoneNum,
    //     token: _that.tokenData,
    //   };
    //   this.$FucPost(this.$store.state.ip + "/submitExtractInfo", obj)
    //     .then(function (res) {
    //       // console.log("submitExtractInfo-res", res);
    //       let resData = res.data;
    //       // console.log("resData", resData);
    //       if (res.code != 200) {
    //         _that.showPopup = true;
    //         _that.popupMsg.content = res.msg;
    //       }
    //       if (res.code == 200) {
    //         _that.showPopup = true;
    //         _that.popupMsg.content = res.msg;
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    changeTilte(e, index) {
      this.titleName = e.title;
      this.cieTitle = index;
      if (index == 0) {
        this.isTitle1 = true;
        this.isTitle2 = false;
      }
      if (index == 1) {
        this.isTitle1 = false;
        this.isTitle2 = true;
      }
    },
    changeExchange(e, index) {
      this.cieExchange = index;
      this.extractListTpye = e.type;
      this.isExchange = true;
      // if(this.isbind==true){
      //   this.isExchange = true
      // }
      // if(this.isbind==false){
      //   this.isExchange = false
      // }
      // this.getCreditInfo(); //newgai
      this.getPayoutInfo();
    },
    handleShowOrHidePopup: function (type) {
      if (type == "yes") {
        // console.log(type)
        this.showPopup = false;
        // location.reload();
      } else {
        // console.log(type)
        this.showPopup = false;
        // location.reload();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.main_content {
  width: 75%;
  float: right;
  color: #fff;
  font-size: 1rem;
  text-align: left;
}
.main-bod {
  border: 0.3125rem solid #bc981e;
  background-color: #000;
  min-height: 18.75rem;
  border-radius: 0.5rem;
}
.title-con {
  border-top-right-radius: 0.5rem;
  border-top-left-radius: 0.5rem;
  display: flex;
  align-items: center;
  background: linear-gradient(
    #7d1f00,
    #912e04,
    #9b2e03,
    #671c00,
    #330b03
  ) !important;
  border-top: solid 0.125rem #902d03;
  border-bottom: solid 0.125rem #5c1e09;
  height: 2.5rem;
}
.title-item {
  cursor: pointer;
  height: 2.5rem;
  line-height: 2.5rem;
  min-width: 6.25rem;
  padding: 0 0.625rem;
  text-align: center;
}
.title-item-sub {
  cursor: pointer;
  text-align: center;
  min-width: 6.25rem;
  color: rgb(236, 197, 22);
  padding: 0 0.625rem;
  height: 2.5rem;
  line-height: 2.5rem;
  background: linear-gradient(
    #7d1f00,
    #2e1004,
    #250c03,
    #2e1004,
    #330b03
  ) !important;
  border-top: solid 0.125rem #902d03;
  border-bottom: solid 0.125rem #5c1e09;
}
.exchange-con {
  margin: 0.9375rem;
  font-size: 0.875rem;
}
.exchange-tip-item {
  margin: 0.625rem 0;
}
.line {
  height: 0.125rem;
  border-bottom: 0.125rem solid rgba(255, 255, 255, 0.671);
  margin: 1.25rem 0;
}
.exchange-med {
  display: flex;
  align-items: center;
}
.exchange-med-item {
  margin: 1.25rem;
  display: flex;
  align-content: center;
  flex-wrap: wrap;
}
.exchange-med-img {
  cursor: pointer;
  width: 9.375rem;
  height: 5rem;
  filter: grayscale(100%);
}
.exchange-med-img-sub {
  cursor: pointer;
  width: 9.375rem;
  height: 5rem;
}
.ipt-wid {
  display: flex;
  align-items: center;
}
.ipt-wid-span{
  color: red;
  margin-left: 0.625rem;
}
.ipt-wid-span-h5{
  color: red;
  display: block;
  margin-top: 0.3125rem;
}
.iptPhr {
   width: 50%;
}
.iptPhr-h5 {
   width: 80%;
}
.ipt-wid-h5 {
  width: 17.5rem;
}
input {
  width: 100%;
  padding: 0.3125rem;
  border-radius: 0.3125rem;
}
.bank-item-gift {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1.25rem 0;
}
.bank-item-left {
  font-size: 0.9375rem;
}
.bank-item-right {
  color: rgb(233, 140, 18);
  padding-bottom: 0.1875rem;
  border-bottom: 0.0625rem solid rgb(233, 140, 18);
}
.submit-con {
  display: flex;
  justify-content: right;
}
.submit {
  color: #000;
  border-radius: 0.25rem;
  font-size: 0.9375rem;
  font-weight: bold;
  padding: 0.625rem 0.9375rem;
  margin: 3.125rem 0 0 0;
  text-align: center;
  border: none;
  background: linear-gradient(45deg, #ce9211, #d3b679, #ce9211);
  cursor: pointer;
}
.submit:hover {
  color: #000;
  margin: 3.125rem 0 0 0;
  text-align: center;
  border-radius: 0.25rem;
  font-size: 0.9375rem;
  font-weight: bold;
  padding: 0.625rem 0.9375rem;
  border: none;
  background: linear-gradient(45deg, #d3b679, #e9a208, #d3b679);
  cursor: pointer;
}
.select {
  text-align: center;
  color: rgb(236, 197, 22);
  margin: 1.25rem 0;
}
.isAct-title {
  color: #fff;
}
.gift-amount {
  margin-left: 0.625rem;
  padding-bottom: 0.3125rem;
  border-bottom: 0.0625rem solid rgb(236, 197, 22);
}
.amount-con {
  color: rgb(236, 197, 22);
  margin: 1.25rem 0;
}
/deep/.el-input__inner {
  height: 1.5625rem;
}
.clo-1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1.25rem 0;
}
.clo-1-title {
  color: rgb(236, 197, 22);
  font-size: 1rem;
}
.clo-1-cte {
  border-bottom: 0.0625rem solid #ffff;
}
.know-con {
  display: flex;
  justify-content: end;
  align-items: center;
  margin-top: 2.5rem;
}
.cieRadio {
  width: 0rem;
  height: 0rem;
}
.know-con-s{
  color: rgba(110, 101, 101, 0.897);
  border-bottom: 0.0625rem solid  rgba(110, 101, 101, 0.897);
}
.know-con-sub{
  color:  rgb(236, 197, 22);
  border-bottom: 0.0625rem solid  rgb(236, 197, 22);
}
</style>
